<template>
  <tr>
    <td
      class="text-center align-middle"
      v-if="showHeader"
      v-bind:rowspan="item.items.length > 1 ? item.items.length : 1"
    >
      <span class="form-control form-control-plaintext">{{
        rowIndex + 1
      }}</span>
    </td>
    <td
      class="form-group text-center align-middle"
      v-if="showHeader && item.activityRemark != null"
      v-bind:rowspan="item.items.length > 1 ? item.items.length : 1"
    >
      {{ item.shopActivityName }}<br />({{ item.activityRemark }})
    </td>
    <td
      class="form-group text-center align-middle"
      v-if="showHeader && item.activityRemark == null"
      v-bind:rowspan="item.items.length > 1 ? item.items.length : 1"
    >
      {{ item.shopActivityName }}
    </td>
    <td
      v-if="showHeader"
      class="form-group text-center "
      v-bind:rowspan="item.items.length > 1 ? item.items.length : 1"
    >
      <div
        v-if="
          !item.isSixActivity || (!item.borrowerIsAgent && !item.shopActivityId)
        "
        class="kt-checkbox-inline"
      >
        <label class="kt-checkbox">
          <input
            type="checkbox"
            :id="'isPickUp' + rowIndex"
            :value="'isPickUp' + rowIndex"
            @change="updatePickUpStatus"
            :checked="item.isPickUp"
            disabled
          />
          <span></span>
        </label>
      </div>
      <div v-else class="kt-checkbox-inline">
        <label class="kt-checkbox">
          <input
            type="checkbox"
            :id="'isPickUp' + rowIndex"
            :value="'isPickUp' + rowIndex"
            @change="updatePickUpStatus"
            :checked="item.isPickUp"
          />
          <span></span>
        </label>
      </div>
    </td>
    <td
      class="form-group align-middle"
      v-if="showHeader"
      width="20%"
      v-bind:rowspan="item.items.length > 1 ? item.items.length : 1"
    >
      <select2
        :css-style="'width: 100%;'"
        :css-class="'form-control'"
        :id="'plProductType' + _uid"
        :name="'plProductType' + _uid"
        :select2-options="jobBTransitOptions"
        @selectChange="onjobBTransitChange"
        v-model="itemjobBTransit"
        data-msg-required="กรุณาเลือกประเภทสินค้า"
      ></select2>
    </td>
    <template v-if="item.items.length > 0">
      <td class="align-middle">{{ item.items[itemIndex].quotaName }}</td>
      <td class="align-middle">
        {{ item.items[itemIndex].materialCode }}
        {{ item.items[itemIndex].productName }}
      </td>
      <td class="text-right align-middle">{{ item.items[itemIndex].qty }}</td>
      <td class="text-right align-middle">
        {{ item.items[itemIndex].baseUnit }}
      </td>
    </template>
    <template v-else>
      <td>&nbsp;</td>
      <td>&nbsp;</td>
      <td>&nbsp;</td>
    </template>
  </tr>
</template>

<script>
import axios from "axios";
import select2 from "../../Shared/Select2";

export default {
  components: {
    select2,
  },
  props: {
    rowIndex: Number,
    itemIndex: Number,
    showHeader: {
      type: Boolean,
      default: true,
    },
    rootItems: {
      type: Array,
      required: true,
    },
    item: {
      type: Object,
      required: true,
    },
  },
  data() {
    var self = this;

    return {
      itemjobBTransit: null,
      jobBTransitOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/Transport/Select2Transport",
          type: "post",
          delay: 300,
          dataType: "json",
          contentType: "application/json",
          data: function(params) {
            var query = {
              search: params.term,
              page: params.page || 1,
              showVendorTransport: true,
              agentCodes: [],
            };

            return JSON.stringify(query);
          },

          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
      },
    };
  },
  methods: {
    onjobBTransitChange: function(id, text, data, ref) {
      var self = this;

      self.item.TransitId = self.itemjobBTransit;
    },
    updatePickUpStatus(e) {
      var self = this;
      if (e.target.checked) {
        self.item.isPickUp = true;
      } else {
        self.item.isPickUp = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// App/Components/Borrow/JobBorrowProductRow.vue